<template>
  <div
    class="z-msg__list"
  >
    <div
      class="z-msg__inner-list"
    >
      <item
        v-for="item of listData"
        :key="item.id"
        :itemData="item"
        @click="itemClick"
      />
    </div>

    <div
      class="msg__operation-item--more"
      @click="loadMore"
    >
      加载更多
    </div>

    <!-- 清空 -->
    <div
      class="msg__operation-item--clear"
      @click="clear"
    >
      清空所有
    </div>
  </div>
</template>

<script>
import item from './item'

export default {
  name: 'z-msg-list',
  components: {
    item,
  },
  props: {
    listData: {
      type: Array,
      required: true,
    }
  },
  methods: {
    itemClick (item) {
      this.$emit('itemClick', item)
    },
    /**
     * 加载更多
    */
    loadMore () {

    },
    /**
     * 清空消息
    */
    clear () {

    }
  }
}
</script>

<style lang="scss" scoped>
.z-msg__list {
  box-sizing: border-box;
}
.z-msg__inner-list {
  width: 100%;
  height: 380px;
  overflow: auto;
}

.msg__operation-item--more,
.msg__operation-item--clear, {
  width: 100%;
  line-height: 35px;
  height: 35px;

  border-bottom: 1px solid #e8e8e8;

  text-align: center;

  font-size: 14px;
  color: rgba(0, 0, 0, 0.65)
}
.msg__operation-item--more {
  border-top: 1px solid #e8e8e8;
  color: #1890ff;
}
</style>
